import { bool, func, shape, string } from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { LayoutSingleColumn, Page } from '../../../components';
import { isScrollingDisabled } from '../../../ducks/ui.duck';
import { injectIntl, intlShape } from '../../../util/reactIntl';
import { propTypes } from '../../../util/types';
import FooterContainer from '../../FooterContainer/FooterContainer';
import { getMetadata } from '../../PageBuilder/PageBuilder';
import TopbarContainer from '../../TopbarContainer/TopbarContainer';
import MerchantHero from './MerchantHero/MerchantHero';
import AppFeatures from './AppFeatures/AppFeatures';
import FeatureGrid from './FeatureGrid/FeatureGrid';
import GoLiveSteps from './GoLiveSteps/GoLiveSteps';
import Pricing from './Pricing/Pricing';
import ContactCta from './ContactCta/ContactCta';
import css from './MerchantHomePage.module.css';

/**
 * Merchant marketing landing — visual reference: for-business.tsx (/for-business).
 * Route: /merchant (LandingPageMerchant).
 */
export const MerchantHomePage = props => {
  const scrollingDisabled = useSelector(isScrollingDisabled);
  const { pageAssetsData, merchantMaybe } = props;
  const meta = pageAssetsData?.meta ? { ...pageAssetsData.meta } : {};
  const pageMetaProps = getMetadata(meta);
  const arabicLanguage =
    typeof window !== 'undefined' && localStorage.getItem('language') === 'Arabic';
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#contact') {
      const el = document.getElementById('contact');
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    }
  }, [location.hash]);

  return (
    <Page {...pageMetaProps} scrollingDisabled={scrollingDisabled} referrer="origin">
      <LayoutSingleColumn
        className={css.merchantMainWrapper}
        mainColumnClassName={css.layoutWrapperMain}
        topbar={<TopbarContainer merchantMaybe={merchantMaybe} />}
        footer={<FooterContainer />}
      >
        <div className={classNames(css.mainWrapper, arabicLanguage && css.arabicDirection)}>
          <MerchantHero />
          <AppFeatures />
          <FeatureGrid />
          <GoLiveSteps />
          <Pricing />
          <ContactCta />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

MerchantHomePage.defaultProps = {
  currentUser: null,
  verificationError: null,
};

MerchantHomePage.propTypes = {
  currentUser: propTypes.currentUser,
  scrollingDisabled: bool.isRequired,
  submitVerification: func.isRequired,
  isVerified: bool,
  emailVerificationInProgress: bool.isRequired,
  verificationError: propTypes.error,
  location: shape({
    search: string,
  }).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(MerchantHomePage);
